import React from 'react'
import {SwipeStyledButton} from "@cabinet-packages/components";

export const SwipeButton = ({onClick, text, disabled}) => {
    const isMedis = process.env.REACT_APP_CURRENT_CLINIC === "MEDIS";

    return <SwipeStyledButton
        animationStart={"left"}
        animationMaterialColor={isMedis ? "#00B3A1" : "#0077C8"}
        buttonMaterialColor={isMedis ? "#FFC101" : "#ffffff"}
        hoverTextColor={"#ffffff"}
        color={isMedis ? "#0E4E4E" : "#0077C8"}
        style={{margin: "10px"}}
        onClick={onClick}
        disabled={disabled}
    >
        {text}
    </SwipeStyledButton>;
}